//export const VK_APP_KEY = 51842276
export const VK_APP_KEY = 51897219
//export const TG_BOT_NAME = 'btpeel_login_test_bot'
export const TG_BOT_NAME = 'btpeel_ru_bot'
